import { render, staticRenderFns } from "./DeactivateTenantModal.vue?vue&type=template&id=5fc5014d&"
import script from "./DeactivateTenantModal.vue?vue&type=script&lang=js&"
export * from "./DeactivateTenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports